import { logger } from "@justhome/common";
import { usePostMaximumBudget } from "@justhome/common/api/core";
import { Loader } from "@justhome/react-ui";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import mapFormToMaximumBudget from "@modules/application/lib/budgetCheck/mapFormToMaximumBudget";
import { BudgetCheckFormValues } from "@modules/application/lib/budgetCheck/types";
import { FC, useEffect } from "react";
import { FormStepComponent } from "../FormSteps/FormSteps";

const BudgetCheckLoading: FC<FormStepComponent<BudgetCheckFormValues>> = ({
  value,
  onNext,
  onPrevious,
}) => {
  const { state, dispatch } = useApplicationContext();
  const { partner } = usePartnerContext();
  const { mutate: postMaximumBudget } = usePostMaximumBudget({
    onSuccess: (maximumBudget) => {
      dispatch({ type: "SET_MAXIMUM_BUDGET", maximumBudget });
      onNext();
    },
    onError: (err) => {
      logger.error("Failed to post maximum budget", err);
      onPrevious();
    },
  });

  useEffect(() => {
    const body = mapFormToMaximumBudget(
      value as BudgetCheckFormValues,
      state.lead?.id,
      partner?.id,
    );

    postMaximumBudget({ body });
  }, [state.lead, partner, value, postMaximumBudget]);

  return (
    <div className="flex flex-col items-center">
      <span className="flex gap items-center">
        <Loader size="md" />
        <span className="text-title-1 opacity-75">
          Dies kann bis zu 10 Sekunden dauern
        </span>
      </span>

      <h1 className="text-app-h1 my-3s">Ergebnisse werden geladen</h1>
    </div>
  );
};

export default BudgetCheckLoading;
